<div class="flex flex-col gap-y-2 h-full">


    @if (completeDocument()) {
    <div
        class="relative flex justify-center rounded-lg overflow-hidden border border-solid border-gray-400 dark:border-white/25 p-4">
        <input #fileInput type="file" accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/txt, text/csv, application/csv, .csv" class="hidden" (change)="selectFile($event)" />
        <button type="button" (click)="fileInput.click()"
            class="absolute top-2 right-2 z-10 text-primary secondary-button">Change</button>

        <div class="sm:flex">
            <div class="mb-4 shrink-0 sm:mr-4 sm:mb-0">
                
                @if (completeDocumentType() === 'application/pdf') {
                    <img class="h-32 w-full hidden dark:block" src="../../../assets/doc-types/pdf-white.png" alt="">
                    <img class="h-32 w-full block dark:hidden" src="../../../assets/doc-types/pdf-black.svg" alt="">
                } @else if (completeDocumentType() === 'application/msword') {
                    <img class="h-32 w-full hidden dark:block" src="../../../assets/doc-types/doc-white.png" alt="">
                    <img class="h-32 w-full dark:hidden block" src="../../../assets/doc-types/doc-black.svg" alt="">
                } @else if (completeDocumentType() === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {

                } @else if (completeDocumentType() === 'text/txt') {
                    <img class="h-32 w-full hidden dark:block" src="../../../assets/doc-types/txt-white.png" alt="">
                    <img class="h-32 w-full dark:hidden block" src="../../../assets/doc-types/txt-black.svg" alt="">
                } @else if (completeDocumentType() === 'text/csv' || completeDocumentType() === 'application/csv') {
                    <img class="h-32 w-full hidden dark:block" src="../../../assets/doc-types/txt-white.png" alt="">
                    <img class="h-32 w-full dark:hidden block" src="../../../assets/doc-types/txt-black.svg" alt="">
                }

            </div>
            <div>
                <h4 class="text-sm font-bold text-primary">{{ completeDocument() }}</h4>
                <p class="mt-1 text-secondary">{{ completeDocumentType() }}</p>
            </div>
        </div>

    </div>
    } @else {
    <div class="flex justify-center rounded-lg border border-dashed px-10 py-6 transition-colors"
        [class]="isDragging() ? 'border-primary bg-primary/10 dark:bg-primary/20' : 'border-gray-400 dark:border-zinc-800'"
        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
        <div class="text-center flex flex-col items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="mx-auto size-10 text-gray-600">
                <path
                    d="M11.35 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5.35" />
                <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                <path d="M14 19h6" />
                <path d="M17 16v6" />
            </svg>
            <div class="mt-4 flex flex-col items-center justify-center text-sm/6"
                [class]="isDragging() ? 'text-accent/90' : 'text-gray-400'">
                <label for="file-upload"
                    class="relative cursor-pointer rounded-md bg-transparent font-semibold text-accent focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:text-accent/90">
                    <span type="button">Upload a Document</span>
                    <input #fileInput id="file-upload" type="file" name="file-upload"
                        accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/txt, text/csv, application/csv, .csv"
                        (change)="selectFile($event)" class="sr-only" />
                </label>
                <p class="pl-1">or drag and drop</p>
            </div>
        </div>
    </div>
    <p class="mt-1 text-xs text-secondary">Upload a PDF, DOC, DOCX, CSV, or text file.</p>
    }
</div>